import React from "react";

import TextField from "@mui/material/TextField";
import Button from "@mui/material/Button";
import FormControl from "@mui/material/FormControl";

import UploadImage from "../components/UploadImage";

import AdminDatePeriodManagerInterface from "../interfaces/AdminPeriodManagerInterface";

import Paper from "@mui/material/Paper";
import Grid from "@mui/material/Grid";

import ItemsEnumeratorInterface from "../interfaces/ItemsEnumeratorInterface";
import AddDimensionInterface from "../interfaces/AddDimensionInterface";
import AddPriceInterface from "../interfaces/AddPriceInterface";

import DeleteOutlineIcon from "@mui/icons-material/DeleteOutline";
import DeleteIcon from "@mui/icons-material/Delete";

import { parseMenuGraphAsTags } from "../components/utils/applibs";

import {
  Typography,
  FormControlLabel,
  Checkbox,
  RadioGroup,
  Radio,
  IconButton,
  Tooltip,
  Chip,
} from "@mui/material";
import CommonDialog from "./utils/Dialogs";
import AdminPickAndSelectMenuTreeInterface from "../interfaces/AdminPickAndSelectMenuTreeInterface";

const SHOW_FREETAGS = false;

function BootstrapTooltip(props) {
  return (
    <Tooltip
      arrow
      {...props}
      componentsProps={{
        tooltip: {
          sx: {
            fontSize: 13,
          },
        },
        arrow: {
          sx: {
            color: "black",
          },
        },
      }}
    />
  );
}

export default function AdminItem(props) {
  const addDimensionRef = React.useRef(null);

  const {
    payProviderMetadata,
    title,
    description,
    location,
    tags,
    tagsAsMenu,
    prices,
    nb,
    available,
    busy,
    files,
    dimensions,
    platforms,
    published,
    isRecurrent,
    hasMultiplePrices,
    isFreeTicket,
    superUser,
    eventPlanner,
    isEvent,
    requiredFormular,
    dataMenus,
    handlePostItem,
    onTitleChange,
    onDescriptionChange,
    onLocationChange,
    onTagsChange,
    onTagsAsMenuChange,
    onNbItemChange,
    onFileChange,
    submitting,
    onCancelAction,
    onDeleteDimension,
    onChangeDimension,
    onAddDimension,
    onUpdateDimension,
    onStatusPublishedChange,
    onSubscriptionChange,
    onMultiplePricesChange,
    onFreeTicketChange,
    onSavePrice,
    onDeleteSavedPrice,
    openDialogPricing,
    onDialogClosePricing,
    dialogPricing,
    onEventPlanner,
    onSetEvent,
    onSetFormular,
    onSaveMenuForItemRefresh,
    onHandleDeleteFile,
  } = props;
  console.log("payProviderMetadata", payProviderMetadata);
  const canUpdatePrice = !payProviderMetadata.product;

  const styles = {
    root: {
      margin: 1,
    },
    title: {
      fontSize: "1.5em",
      fontWeight: "normal",
    },
    price: {
      float: "left",
      marginTop: 14,
      width: 120,
      marginLeft: 10,
    },
    uploadImage: {
      margin: "20px auto",
    },
    published: {
      display: "flex",
      flexDirection: "row",
    },
    actions: {
      display: "flex",
      justifyContent: "space-evenly",
      marginTop: 40,
      padding: "10px 0",
    },
    itemCategory: {
      margin: "10px auto 10px auto",
      width: "100%",
    },
    grid: {
      padding: 10,
      marginBottom: 10,
    },
    tagsAsMenu: {
      padding: 10,
      marginBottom: 10,
      flexDirection: "row",
      justifyContent: "space-evenly",
      display: "flex",
    },
    tagAsMenu: {
      margin: "0 10px",
    },
    image: {
      height: 60,
    },
  };

  const { id = null } = props.currentItem || {};

  const titleFormatted = id ? `${title} [#${id}]` : title;

  const [openMenuDialog, setOpenMenuDialog] = React.useState(false);

  const handleClickAssignItemsToMenu = () => {
    setOpenMenuDialog(true);
  };

  const handleMenuDialogClose = (refetchData = false) => {
    setOpenMenuDialog(false);
    if (refetchData) {
      onSaveMenuForItemRefresh();
    }
  };

  const tagsRenderedAsLabel = parseMenuGraphAsTags(dataMenus || []).filter(
    (m) => tagsAsMenu.some((tm) => tm === m.key)
  );

  const hasTags = tags.length > 0;

  const dimensionFormatted = (dimension) => {
    // if supplement then add supplement amout also, for both cases
    // also add the optional flag
    return dimension.multipleChoice
      ? `${dimension.title} (multichoix, max ${dimension.maxChoices}, supplément ${dimension.paidSupplement ? `${dimension.amountSupplement} chf` : 0} ${dimension.optionalDimension ? ", optionnel" : ""})`
      : `${dimension.title} (choix unique, supplément ${dimension.paidSupplement ? `${dimension.amountSupplement} chf` : 0} ${dimension.optionalDimension ? ", optionnel" : ""})`;
  };

  const handleEditDimension = (dimensionType) => {
    const dimensionToEdit = dimensions.find((d) => d.type === dimensionType);
    if (dimensionToEdit && addDimensionRef.current) {
      addDimensionRef.current.openDialogWithDimension(dimensionToEdit);
    }
  };

  return (
    <React.Fragment>
      <h1 style={styles.title}>{titleFormatted}</h1>
      <form noValidate autoComplete="off" style={styles.root}>
        <Grid container spacing={3}>
          <Grid md={6} item xs={12}>
            <Paper style={styles.grid} spacing={3}>
              <FormControl fullWidth>
                <TextField
                  label="Nom de l'article *"
                  margin="normal"
                  onChange={onTitleChange}
                  variant="outlined"
                  value={title}
                />
              </FormControl>
              <FormControl>
                <RadioGroup
                  style={styles.published}
                  aria-label="status"
                  name="status"
                  value={published.toString()}
                  onChange={onStatusPublishedChange}
                >
                  <FormControlLabel
                    value="1"
                    control={<Radio />}
                    label="Publié"
                  />
                  <FormControlLabel
                    value="0"
                    control={<Radio />}
                    label="Non publié"
                  />
                </RadioGroup>
              </FormControl>

              <BootstrapTooltip
                title={`Cochez l'option dans le cas où votre article est lié à un événement.`}
              >
                <FormControl fullWidth>
                  <FormControlLabel
                    control={
                      <Checkbox
                        checked={isEvent === "1"}
                        onChange={onSetEvent}
                        color="primary"
                        inputProps={{ "aria-label": "secondary checkbox" }}
                      />
                    }
                    label="Associer une billetterie pour cet article"
                  />
                </FormControl>
              </BootstrapTooltip>

              <BootstrapTooltip
                title={`Le formulaire de livraison est généralement associé à l'envoi d'un produit physique.`}
              >
                <FormControl fullWidth>
                  <FormControlLabel
                    control={
                      <Checkbox
                        checked={requiredFormular === "1"}
                        onChange={onSetFormular}
                        color="primary"
                        inputProps={{ "aria-label": "secondary checkbox" }}
                      />
                    }
                    label="Formulaire de livraison requis."
                  />
                </FormControl>
              </BootstrapTooltip>

              <FormControl fullWidth>
                <TextField
                  multiline
                  rows="4"
                  label="Description *"
                  margin="normal"
                  onChange={onDescriptionChange}
                  variant="outlined"
                  value={description}
                />
              </FormControl>

              <Paper style={styles.grid}>
                <TextField
                  label="Nombre d'unités (max. 1000)"
                  margin="normal"
                  onChange={onNbItemChange}
                  variant="outlined"
                  value={nb}
                />
                <FormControl fullWidth>
                  Stock disponible <span>{available}</span>
                </FormControl>
                <br />
                <FormControl>
                  Vendu / en cours de vente <span>{busy}</span>
                </FormControl>
              </Paper>

              <Paper style={styles.grid}>
                <Button
                  variant="contained"
                  onClick={openDialogPricing}
                  disabled={isFreeTicket}
                >
                  Ajouter un prix *
                </Button>
                <div>
                  {(prices || []).map((p, key) => (
                    <div key={key}>
                      <IconButton
                        edge="end"
                        aria-label="delete"
                        onClick={() => {
                          onDeleteSavedPrice(p.currency);
                        }}
                        size="large"
                      >
                        <DeleteOutlineIcon />
                      </IconButton>
                      <span style={styles.price}>
                        {`${p.price} ${p.currency}`}
                        {p.priceLabel ? ` : ${p.priceLabel}` : null}
                      </span>
                    </div>
                  ))}
                </div>
                <CommonDialog
                  title="Ajouter un prix"
                  onClose={onDialogClosePricing}
                  open={dialogPricing}
                  render={() => <AddPriceInterface onSavePrice={onSavePrice} />}
                />

                <FormControl>
                  <FormControlLabel
                    control={
                      <Checkbox
                        checked={isFreeTicket}
                        onChange={onFreeTicketChange}
                      />
                    }
                    label="Billet gratuit"
                  />
                </FormControl>

                <FormControl>
                  <RadioGroup
                    style={styles.published}
                    aria-label="subscription"
                    name="subscription"
                    value={isRecurrent.toString()}
                    onChange={onSubscriptionChange}
                  >
                    <FormControlLabel
                      value="0"
                      disabled={!canUpdatePrice || isFreeTicket}
                      control={<Radio />}
                      label="Paiment unique"
                    />
                    <FormControlLabel
                      disabled={!canUpdatePrice || isFreeTicket}
                      value="1"
                      control={<Radio />}
                      label="Abonnement"
                    />
                  </RadioGroup>
                </FormControl>

                <hr />
                <FormControl>
                  {/* ajouter une checkbox "plusieurs prix pour cet article" */}
                  <FormControlLabel
                    disabled={isFreeTicket}
                    control={
                      <Checkbox
                        checked={hasMultiplePrices}
                        onChange={onMultiplePricesChange}
                      />
                    }
                    label="Plusieurs prix pour cet article"
                  />
                  <span style={{ fontSize: "0.8em", color: "#666" }}>
                    (exemple: prix grande pizza, prix petite pizza)
                    <br />
                    Décocher pour un seul prix par article. NE CONSERVE QU'UN
                    SEUL PRIX PAR DEVISE !
                  </span>
                </FormControl>
              </Paper>
              <div>
                {files.length > 0
                  ? (files || []).map((f, key) => (
                      <div key={key}>
                        <img
                          key={key}
                          style={styles.image}
                          alt={`Item illustration for '${title}'`}
                          src={`${process.env.REACT_APP_BUCKETS3}${f}`}
                        />
                        <Button
                          // onClick={() => console.log("delete...", f, key)}
                          onClick={() => onHandleDeleteFile(f, key)}
                        >
                          <DeleteIcon />
                        </Button>
                      </div>
                    ))
                  : null}
              </div>
              <div style={styles.uploadImage}>
                <UploadImage onFileChange={onFileChange} />
              </div>
            </Paper>
          </Grid>
          <Grid md={6} item xs={12}>
            <Paper style={styles.grid}>
              <Typography variant="h6">Caractériques</Typography>
              <FormControl fullWidth>
                {Array.isArray(dimensions)
                  ? dimensions.map((d, key) => (
                      <div key={key} style={styles.itemCategory}>
                        <ItemsEnumeratorInterface
                          key={key}
                          title={dimensionFormatted(d)}
                          values={d.items}
                          type={d.type}
                          multipleChoice={d.multipleChoice}
                          canDelete={true}
                          onChange={onChangeDimension}
                          onDelete={onDeleteDimension}
                          onEdit={handleEditDimension}
                        ></ItemsEnumeratorInterface>
                      </div>
                    ))
                  : null}
              </FormControl>

              <FormControl>
                <AddDimensionInterface
                  ref={addDimensionRef}
                  onAddDimension={onAddDimension}
                  onUpdateDimension={onUpdateDimension}
                ></AddDimensionInterface>
              </FormControl>
            </Paper>
            <Paper style={styles.grid}>
              {SHOW_FREETAGS ? (
                <ItemsEnumeratorInterface
                  className={styles.extraMarginTop}
                  title={`Mot-clés de l'article`}
                  values={typeof tags === "string" ? tags.split(",") : tags}
                  type={`tags`}
                  canDelete={false}
                  onChange={onTagsChange}
                ></ItemsEnumeratorInterface>
              ) : null}

              {hasTags || true ? (
                <React.Fragment>
                  <Button
                    onClick={handleClickAssignItemsToMenu}
                    variant="contained"
                  >
                    Lier/retirer des labels pour cette article
                  </Button>
                  <div style={styles.tagsAsMenu}>
                    {tagsRenderedAsLabel ||
                      [].map((t) => (
                        <Chip
                          style={styles.tagAsMenu}
                          key={t.key}
                          label={t.label}
                        />
                      ))}
                  </div>
                </React.Fragment>
              ) : null}

              <CommonDialog
                title="Lier/retirer des labels pour cette article"
                onClose={() => {
                  handleMenuDialogClose(false);
                }}
                open={openMenuDialog}
                render={() => (
                  <AdminPickAndSelectMenuTreeInterface
                    onCancelAction={() => {
                      handleMenuDialogClose(false);
                    }}
                    callback={() => {
                      handleMenuDialogClose(true);
                    }}
                    onChange={onTagsAsMenuChange}
                    selectedMenus={tagsAsMenu}
                    dataMenus={dataMenus}
                  />
                )}
              />
            </Paper>
            <br />
            {isEvent === "1" ? (
              <Paper style={styles.grid}>
                <div>
                  {/* add an input field for the event location */}
                  <TextField
                    label="Lieu de l'événement"
                    margin="normal"
                    onChange={onLocationChange}
                    variant="outlined"
                    value={location || ""}
                    fullWidth
                  />
                </div>
                <div>
                  <AdminDatePeriodManagerInterface
                    label="Période l'événement"
                    dateId="dateEvent"
                    date={eventPlanner.dateEvent}
                    onEventPlanner={onEventPlanner}
                  />
                  <AdminDatePeriodManagerInterface
                    label="Période de vente"
                    dateId="dateSale"
                    date={eventPlanner.dateSale}
                    onEventPlanner={onEventPlanner}
                  />
                </div>
              </Paper>
            ) : null}
            <Paper style={styles.grid}>
              <Typography variant="h6">
                Sites de publication de l'article
              </Typography>
              <FormControl>
                {(platforms || []).map((p) => (
                  <FormControlLabel
                    key={p.id}
                    control={<Checkbox checked={true} name={p.id} />}
                    label={p.name}
                  />
                ))}
              </FormControl>
            </Paper>
          </Grid>
        </Grid>
      </form>
      <div style={styles.actions}>
        {!superUser ? (
          <Button
            variant="contained"
            disabled={
              submitting ||
              title === "" ||
              description === "" ||
              (!isFreeTicket && prices.length === 0)
            }
            onClick={handlePostItem}
          >
            {submitting ? "processing ..." : "Sauver"}
          </Button>
        ) : null}
        <Button
          variant="contained"
          disabled={submitting}
          onClick={onCancelAction}
        >
          Annuler
        </Button>
      </div>
    </React.Fragment>
  );
}
